import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, useRouter, } from '@tanstack/react-router';
import { useCallback, } from 'react';
import { prop, } from 'remeda';
import { api, } from '../../../../api/Api.js';
import { ImportedTherapistSearch, } from '../../../../pages/therapist/imported/ImportedTherapistSearch.js';
export const Route = createFileRoute('/therapist/imported')({
    validateSearch(search) {
        if (typeof search.displayName === 'string') {
            return {
                displayName: search.displayName,
            };
        }
        return {};
    },
    loaderDeps: prop('search'),
    async loader({ deps: search }) {
        return await api.therapist.imported.search.request(search);
    },
    component: ImportedTherapistSearchWrapper,
});
function ImportedTherapistSearchWrapper() {
    const search = Route.useSearch();
    const response = Route.useLoaderData();
    const router = useRouter();
    const navigate = Route.useNavigate();
    const setSearch = useCallback((newSearch) => {
        void navigate({
            search: newSearch,
            replace: true,
            resetScroll: false,
        });
    }, [navigate]);
    const refresh = useCallback(async () => {
        await router.invalidate();
    }, [router]);
    if (response.status !== 'ok') {
        return _jsx("div", { children: "Error in loader" });
    }
    return (_jsx(ImportedTherapistSearch, { search: search, setSearch: setSearch, response: response, refresh: refresh }));
}
//# sourceMappingURL=route.js.map